import common_en from './en/common.json';
import home_en from './en/home.json';
import about_en from './en/about.json';
import auth_en from './en/auth.json';
import creator_en from './en/creator.json';
import profile_en from './en/profile.json';
import collab_en from './en/collab.json';
import business_en from './en/business.json';
import product_en from './en/product.json';
import brands_en from './en/brands.json';
import creators_landing_en from './en/creators_landing.json';
import partners_en from './en/partners.json';
import admin_en from './en/admin.json';
import legal_en from './en/legal.json';
import reservations_en from './en/reservations.json';

import common_es from './es/common.json';
import home_es from './es/home.json';
import about_es from './es/about.json';
import auth_es from './es/auth.json';
import creator_es from './es/creator.json';
import profile_es from './es/profile.json';
import collab_es from './es/collab.json';
import business_es from './es/business.json';
import product_es from './es/product.json';
import brands_es from './es/brands.json';
import creators_landing_es from './es/creators_landing.json';
import partners_es from './es/partners.json';
import admin_es from './es/admin.json';
import legal_es from './es/legal.json';
import reservations_es from './es/reservations.json';

import common_pt from './pt/common.json';
import home_pt from './pt/home.json';
import about_pt from './pt/about.json';
import auth_pt from './pt/auth.json';
import creator_pt from './pt/creator.json';
import profile_pt from './pt/profile.json';
import collab_pt from './pt/collab.json';
import business_pt from './pt/business.json';
import product_pt from './pt/product.json';
import brands_pt from './pt/brands.json';
import creators_landing_pt from './pt/creators_landing.json';
import partners_pt from './pt/partners.json';
import admin_pt from './pt/admin.json';
import legal_pt from './pt/legal.json';
import reservations_pt from './pt/reservations.json';

export const resources = {
  en: {
    common: common_en,
    home: home_en,
    about: about_en,
    auth: auth_en,
    creator: creator_en,
    profile: profile_en,
    collab: collab_en,
    business: business_en,
    product: product_en,
    brands: brands_en,
    creators_landing: creators_landing_en,
    partners: partners_en,
    admin: admin_en,
    legal: legal_en,
    reservations: reservations_en,
  },
  es: {
    common: common_es,
    home: home_es,
    about: about_es,
    auth: auth_es,
    creator: creator_es,
    profile: profile_es,
    collab: collab_es,
    business: business_es,
    product: product_es,
    brands: brands_es,
    creators_landing: creators_landing_es,
    partners: partners_es,
    admin: admin_es,
    legal: legal_es,
    reservations: reservations_es,
  },
  pt: {
    common: common_pt,
    home: home_pt,
    about: about_pt,
    auth: auth_pt,
    creator: creator_pt,
    profile: profile_pt,
    collab: collab_pt,
    business: business_pt,
    product: product_pt,
    brands: brands_pt,
    creators_landing: creators_landing_pt,
    partners: partners_pt,
    admin: admin_pt,
    legal: legal_pt,
    reservations: reservations_pt,
  }
};
